export const WHITELIST_TURBO_CAMPAIGN_PRODUCTION = [
    'pen-venture.myshopify.com',
    'milliard-brands.myshopify.com',
    'shopwebbys.myshopify.com',
    'kateliva.myshopify.com',
    '6e5449.myshopify.com',
    '5cb94e.myshopify.com',
    'pmr-customs.myshopify.com',
    'fc3821.myshopify.com',
    '5f2e5c-2.myshopify.com',
    'dc6efa-5.myshopify.com',
    'toledo-dealer-services.myshopify.com',
    '6c3482.myshopify.com',
    'keelaoutdoors.myshopify.com',
    'kickback-shoes.myshopify.com',
    'sani-tech-ca.myshopify.com',
    'anabolix-nutrition.myshopify.com',
    'sullysathleticservices.myshopify.com',
    'esmaison.myshopify.com',
    'trudiamonds-co-uk.myshopify.com',
    'barnett-swe.myshopify.com',
    '33d38e-3.myshopify.com',
    'new-enerj.myshopify.com',
    '1d0f07.myshopify.com',
    'cwjewellers.myshopify.com',
    'caffetteria-stazione.myshopify.com',
    'stagingxplct.myshopify.com',
    'italeau2.myshopify.com',
    'sabellah.myshopify.com',
    '64f252.myshopify.com',
    'moms-the-word-2.myshopify.com',
    '1db526-2.myshopify.com',
    '568a79-5.myshopify.com',
    '2amstudioofficial.myshopify.com',
    'lunalaeb2b.myshopify.com',
    '9071cb-2.myshopify.com',
    'west-coast-garage-2024.myshopify.com',
    'a1598b-2.myshopify.com',
    '035cf4-f8.myshopify.com',
    'origin-kicks.myshopify.com',
    'strut-menwear.myshopify.com',
    'needrepair-2-0.myshopify.com',
    'kaiiathelabel.myshopify.com',
    'xn-n8jvb278m3eo8wkgij61s.myshopify.com',
    'happytailsme.myshopify.com',
    'brand-ring.myshopify.com',
    'snow-moon-press-shop.myshopify.com',
    'kisses-9584.myshopify.com',
    'saltaire-antiques.myshopify.com',
    'stayhumanonearth.myshopify.com',
    '56908d.myshopify.com',
    'authenticstreetsigns.myshopify.com',
    'used-legends-direct.myshopify.com',
    'vado-welog-b2c.myshopify.com',
    'doghouse-distillery-new-build.myshopify.com',
    'c7d614.myshopify.com',
    'avahcouturefashion.myshopify.com',
    'scoutandrebel.myshopify.com',
    'impactcoach.myshopify.com',
    '8d0aa9-2.myshopify.com',
    'piccadilly-ecuador.myshopify.com',
    'contact-769.myshopify.com',
    'by-creosa.myshopify.com',
    'jor-studios.myshopify.com',
    'barnettdeutschland.myshopify.com',
    'elektroretailwebshop.myshopify.com',
    'thegowngalleria.myshopify.com',
    'garage89-1009-3.myshopify.com',
    'mascolimpcl.myshopify.com',
    'divas-anne.myshopify.com',
    'bella-epoca-zapateria.myshopify.com',
    'hiseeoptic.myshopify.com',
    'crossfor.myshopify.com',
    'tile-boutique-new.myshopify.com',
    '1c912d-2.myshopify.com',
    '42cf24.myshopify.com',
    'onerugged.myshopify.com',
    'a0393b.myshopify.com',
    'shop-chevalier.myshopify.com',
    'southwest-motorhomes.myshopify.com',
    'sheepdogmics-com.myshopify.com',
    'truth-beauty-kw.myshopify.com',
    'beauty-plus-chile.myshopify.com',
    'ferramenta-barile.myshopify.com',
    'ynlio.myshopify.com',
    'casa-kay.myshopify.com',
    'otootje.myshopify.com',
    'jewelerstradeshop.myshopify.com',
    'flomotion-store.myshopify.com',
    'shop-atlantic-kids.myshopify.com',
    'shopxclusivesneakers.myshopify.com',
    '1ce5ff-2.myshopify.com',
    'mundo-outdoors-shop.myshopify.com',
    '5330ec-2.myshopify.com',
    '274c66-2.myshopify.com',
    'global-picollet.myshopify.com',
    'deniliquin-jewellers.myshopify.com',
    'old-school-ritual.myshopify.com',
    'piscines-et-spas-poseidon.myshopify.com',
    'ouros-jewels.myshopify.com',
    'gewerbefabrik.myshopify.com',
    'secondhandbags-ag.myshopify.com',
    'steel-barnett.myshopify.com',
    'turquoiseoficial.myshopify.com',
    'magnolia-fashion-group.myshopify.com',
    'worthington-millwork.myshopify.com',
    'lady-epis-shoppe.myshopify.com',
    'aph-supplements-v3.myshopify.com',
    'xn-rss49j3pis1mu86b.myshopify.com',
    'i-gr.myshopify.com',
    'ciss-cola.myshopify.com',
    'pixuskeekokids.myshopify.com',
    'achilles-ec.myshopify.com',
    'e2054b.myshopify.com',
    '2105eb.myshopify.com',
    'suzysfine-jewellery.myshopify.com',
    '2e813f.myshopify.com',
    '79643b-3.myshopify.com',
    'repairfirst-einshoch.myshopify.com',
    'b1c5b2.myshopify.com',
    'sahara-jewellery.myshopify.com',
    'visiontek-com.myshopify.com',
    'six-moon-designs.myshopify.com',
    'upper-level-916.myshopify.com',
    'barnettuk.myshopify.com',
    'fibrany-eshop.myshopify.com',
    'jordans-jewellers.myshopify.com',
    'luxstreetfashion.myshopify.com',
    'www-kidshoesdirect-com.myshopify.com',
    'the-led-warehouse-llc.myshopify.com',
    'eficonversions.myshopify.com',
    'oneill-nz.myshopify.com',
    'kidiliz-usa.myshopify.com',
    'mastmotorsports.myshopify.com',
    'coronado-casuals-comp-shop.myshopify.com',
    'zelljoy.myshopify.com',
    'forces-marketplace.myshopify.com',
    'enerskin.myshopify.com',
    'franklin-art-studio.myshopify.com',
    'freequent01.myshopify.com',
    'brew-culture-craft-brewing-supplies.myshopify.com',
    'max-muscle-sports-nutrition.myshopify.com',
    'theplantbasestore.myshopify.com',
    'ctb-performance-and-accessories.myshopify.com',
    'blackbass-store.myshopify.com',
    'tyrelift.myshopify.com',
    'moderntype-business-forms.myshopify.com',
    'netafimitaly.myshopify.com',
    'classique-4.myshopify.com',
    'the-pyjama-factory.myshopify.com',
    '3below-com.myshopify.com',
    'stash-tea.myshopify.com',
    'naturya.myshopify.com',
    'wolfathletics.myshopify.com',
    'robertprice.myshopify.com',
    'twowheelsempire.myshopify.com',
    'classiqueau.myshopify.com',
    'zahava-tel-aviv.myshopify.com',
    'sonja-quandt.myshopify.com',
    'humble-grape.myshopify.com',
    'hunters-element.myshopify.com',
    'postergroup-2019.myshopify.com',
    'jolie-bra-and-lingerie-boutique.myshopify.com',
    'quality-laser-supply.myshopify.com',
    'luxe-game-tables.myshopify.com',
    'furr-bulous.myshopify.com',
    'provincialcabinets.myshopify.com',
    'rusticreach.myshopify.com',
    'seikoshopin.myshopify.com',
    'saveon-sport.myshopify.com',
    'acrdig-dev.myshopify.com',
    'voila-par-andreanne.myshopify.com',
    'yellowearthaus.myshopify.com',
    'radiantwholefood.myshopify.com',
    'weconhome.myshopify.com',
    'dolcemediterraneo.myshopify.com',
    'supply-drop-4323.myshopify.com',
    'southern-drawl-store.myshopify.com',
    'facemeetcp.myshopify.com',
    'ba084c.myshopify.com',
    'etonic1876.myshopify.com',
    'loefly.myshopify.com',
    '13606c-3.myshopify.com',
    'cocochic-official.myshopify.com',
    '1395c7.myshopify.com',
    'barna-resources.myshopify.com',
    'the-freeze-dried-candy-store-wholesale.myshopify.com',
    'steep-mountain-tea.myshopify.com',
    'the-thrifting-den.myshopify.com',
    'c2b03d-3.myshopify.com',
    'satoyaku.myshopify.com',
    'nutramedix-products.myshopify.com',
    'the-good-meal-co.myshopify.com',
    '925fd1-5.myshopify.com',
    'medacart-com.myshopify.com',
    'furniture-pop-up-shop.myshopify.com',
    'frantz-tierbedarf.myshopify.com',
    'higher-quality-seed-corp.myshopify.com',
    'carstomised.myshopify.com',
    '5c1d9d.myshopify.com',
    'the-disposable-wholesale.myshopify.com',
    'just-the-wright-interiors.myshopify.com',
    'eddiebauer-jp.myshopify.com',
    'f701b3.myshopify.com',
    'ogaard-sailboards-ltd.myshopify.com',
    '1b1951.myshopify.com',
    'twgtea.myshopify.com',
    'zvoovfashion.myshopify.com',
    'bdc21b-2.myshopify.com',
    '6f3b99-3.myshopify.com',
    'mixperfume.myshopify.com',
    '9e54de.myshopify.com',
    'hello-123456789123457030.myshopify.com',
    'stauer-private-vault.myshopify.com',
    'lovely-retro-renos.myshopify.com',
    'atlas-target-works.myshopify.com',
    'framing-to-a-t-melbourne.myshopify.com',
    'lapisbardd.myshopify.com',
    'ringosamurai.myshopify.com',
    'theposterink.myshopify.com',
    'xn-ehqu87b60u6ra.myshopify.com',
    'jaspergarden.myshopify.com',
    'waxing-kara.myshopify.com',
    '79510b-2.myshopify.com',
    'frockandfrill.myshopify.com',
    'vrjewels-us.myshopify.com',
    'c0e718.myshopify.com',
    'tn-americas.myshopify.com',
    'wd-electronics.myshopify.com',
    'livinlinens.myshopify.com',
    'parrotstation-com.myshopify.com',
    'f2d87b.myshopify.com',
    'd9daeb-04.myshopify.com',
    'clinik-shop.myshopify.com',
    'tur-og-sko.myshopify.com',
    'betty-and-biddy.myshopify.com',
    'wine-vitage.myshopify.com',
    'akok-in.myshopify.com',
    'cofra.myshopify.com',
    'nomuristore.myshopify.com',
    'avicenna-scrubs.myshopify.com',
    'grevers-winkel.myshopify.com',
    'defiantautoparts.myshopify.com',
    'urban-drivestyle-2.myshopify.com',
    'chicprestige-it.myshopify.com',
    'albercas-y-punto.myshopify.com',
    'poe-net.myshopify.com',
    'f8bc06.myshopify.com',
    'rodeoh-b2b.myshopify.com',
    'melcou-fabrics.myshopify.com',
    'd0a140.myshopify.com',
    '94a5e2-2.myshopify.com',
    'b056dc.myshopify.com',
    '683b14.myshopify.com',
    'contact-675.myshopify.com',
    '7db659-3.myshopify.com',
    'e58cb6.myshopify.com',
    '140b10-2.myshopify.com',
    'misfit-world-meets.myshopify.com',
    'harryrockslondon.myshopify.com',
    'patio-fever.myshopify.com',
    'underland-offroad.myshopify.com',
    'rugtastic-au.myshopify.com',
    'piper-finn.myshopify.com',
    'jclanctot.myshopify.com',
    'lithos-diamonds.myshopify.com',
    'loon-outdoors.myshopify.com',
    'jwl5.myshopify.com',
    '53cf89-2.myshopify.com',
    '22f663.myshopify.com',
    'pell-1990.myshopify.com',
    'ba1b4d.myshopify.com',
    'next-fireplace.myshopify.com',
    'the-persian-rug-store-1.myshopify.com',
    'happyaslarrydesigns.myshopify.com',
    'the-eczema-company.myshopify.com',
    'kamashoinc-2.myshopify.com',
    'rashidcassimsports.myshopify.com',
    'demakers.myshopify.com',
    '559490-3.myshopify.com',
    'minjion.myshopify.com',
    '70f8a8.myshopify.com',
    'prestigeclt.myshopify.com',
    'royal-vanities-au.myshopify.com',
    '6aa06b-2.myshopify.com',
    'uyeki-online-shop.myshopify.com',
    'ipanemasouthafrica.myshopify.com',
    'site-garant.myshopify.com',
    'verb-by-pallavi-singhee.myshopify.com',
    'sophias-costume.myshopify.com',
    'scorpifyus.myshopify.com',
    'roma-customers.myshopify.com',
    'glerupsdanmark.myshopify.com',
    'scarboro-mazda.myshopify.com',
    'balaerke.myshopify.com',
    'tierurnen-manufaktur.myshopify.com',
    'cielkocka.myshopify.com',
    'rockstarjeans123.myshopify.com',
    'the-wrong-number-bucket.myshopify.com',
    'lumi-lighting.myshopify.com',
    'e-s-motorsports.myshopify.com',
    'wazookah-azaani.myshopify.com',
    'kb-ottawa-plants.myshopify.com',
    'classicfightshop.myshopify.com',
    'pixusjacquelinesscrubs.myshopify.com',
    'jackall-online-shop.myshopify.com',
    '22117b.myshopify.com',
    'martinez-3670.myshopify.com',
    '784b55-3.myshopify.com',
    'maison-venu-7432.myshopify.com',
    'wearhouse-com-au.myshopify.com',
    'f21717-3.myshopify.com',
    'hairlaya.myshopify.com',
    'foolsgoldrecs.myshopify.com',
    '86fce4.myshopify.com',
    'glerups-eu.myshopify.com',
    'thelinebyk.myshopify.com',
    'to-go-by-scanpan.myshopify.com',
    'joyeria-castro.myshopify.com',
    'axis-parts.myshopify.com',
    'outlet-sb.myshopify.com',
    'http-www-barnettsports-it.myshopify.com',
    'wybotpool.myshopify.com',
    'dubai-jewellers-2226.myshopify.com',
    'pre-packs.myshopify.com',
    'kikis-quilt-shack.myshopify.com',
    '8b47e9-2.myshopify.com',
    'dbf909.myshopify.com',
    'kandakirat.myshopify.com',
    'bull-and-briar-leather-llc.myshopify.com',
    'lagattaconglistivali-store.myshopify.com',
    'gem-center-usa-wholesale.myshopify.com',
    'oh-thanks.myshopify.com',
    'e4aa55-2.myshopify.com',
    'um-x-flanci.myshopify.com',
    'jp-rituals.myshopify.com',
    'blctest.myshopify.com',
    'inkspire-japan.myshopify.com',
    'mother-murphys.myshopify.com',
    'plow-jewelry.myshopify.com',
    'cosina.myshopify.com',
    'lodevole.myshopify.com',
    'landmann-shop.myshopify.com',
    'enen-store.myshopify.com',
    'winesonlinenz.myshopify.com',
    'away-that-day.myshopify.com',
    'dripcityjewellers.myshopify.com',
    '3aec80-2.myshopify.com',
    'carner-bcn.myshopify.com',
    '736bc9.myshopify.com',
    '10b613-3.myshopify.com',
    '29072c.myshopify.com',
    '973e35-3.myshopify.com',
    'consequence-store.myshopify.com',
    'nbluxe-us.myshopify.com',
    'f145f0-4.myshopify.com',
    'chargit-store.myshopify.com',
    '534639-3.myshopify.com',
    'disposableclouds.myshopify.com',
    'ci-store-7176.myshopify.com',
    '7a5637.myshopify.com',
    'd76af7-3.myshopify.com',
    '085e09-2.myshopify.com',
    'lriplwebsote.myshopify.com',
    'brooklyn-bred-since-1930.myshopify.com',
    'warrior-strong-lifestyle.myshopify.com',
    'vitrashop-f514.myshopify.com',
    'stacey-817.myshopify.com',
    'volcano-gaming-8840.myshopify.com',
    'artvocate.myshopify.com',
    'herzog-jewelers.myshopify.com',
    '901f3c.myshopify.com',
    'alkemispaint.myshopify.com',
    'neudot-lifestyle.myshopify.com',
    'cool-crutches.myshopify.com',
    'aed-team.myshopify.com',
    '753653-2.myshopify.com',
    '4f1b22-3.myshopify.com',
    'adachi-hanga.myshopify.com',
    'take-five-trading.myshopify.com',
    '019d6b-3.myshopify.com',
    '54769c-2.myshopify.com',
    '2787fc-4.myshopify.com',
    'dressandcotton.myshopify.com',
    'ipekyol-ksa.myshopify.com',
    'cave-brizzle.myshopify.com',
    'naissance-uk.myshopify.com',
    'canadabarnett.myshopify.com',
    'barnett-polska.myshopify.com',
    'shinycustomstore.myshopify.com',
    'flexible-neon.myshopify.com',
    'old-grumpy-guys.myshopify.com',
    'hansel-stone-us.myshopify.com',
    'greenleafcrosby.myshopify.com',
    'cork-3593.myshopify.com',
    'c0be7c.myshopify.com',
    'bunker-hill-design-plllc.myshopify.com',
    'f09141.myshopify.com',
    'd3e2a3-3.myshopify.com',
    'omakase-tokyo.myshopify.com',
    '349af0-3.myshopify.com',
    'airthreads.myshopify.com',
    '4c59ff-4.myshopify.com',
    'c705b6.myshopify.com',
    '97e80e-3.myshopify.com',
    'feltrexcl.myshopify.com',
    'nkl-1.myshopify.com',
    'studio-l-u-x.myshopify.com',
    'atica-brand.myshopify.com',
    'zoot-sports-europe.myshopify.com',
    'mr-riegillio.myshopify.com',
    'bryarwolf.myshopify.com',
    'nailstry-store.myshopify.com',
    'swayliving.myshopify.com',
    'riobrewing.myshopify.com',
    'riley-street-art-supply.myshopify.com',
    'yourchaussures.myshopify.com',
    'hemsleys.myshopify.com',
    'fermento24.myshopify.com',
    'uspa-au.myshopify.com',
    'nadri-wholesale.myshopify.com',
    'trimleaf-canada.myshopify.com',
    'manssion.myshopify.com',
    'fierce-forward.myshopify.com',
    'cape-film-supply.myshopify.com',
    'apple-watch-armband.myshopify.com',
    'kolbe-academy-book-store.myshopify.com',
    'eyewear-jonathancate-com.myshopify.com',
    'wijaya-gems.myshopify.com',
    'exceed-footwear-limited.myshopify.com',
    'cap-rouge.myshopify.com',
    'iydjewelry.myshopify.com',
    'sugarilla-shop.myshopify.com',
    '316collection.myshopify.com',
    'intymen.myshopify.com',
    'meatartisan.myshopify.com',
    'harley-butler-trading-company-llc.myshopify.com',
    'secret-day-spa.myshopify.com',
    'imagineworks.myshopify.com',
    'jamclothingsa.myshopify.com',
    'if-coco.myshopify.com',
    'tchooz-shoes.myshopify.com',
    'fratelliorsini-usa.myshopify.com',
    'storefeatheredfriends.myshopify.com',
    'airdoordistributors-com.myshopify.com',
    'objectt-optik.myshopify.com',
    'kentwool.myshopify.com',
    'spielefurst.myshopify.com',
    'wild-valley-supply.myshopify.com',
    'montbell-outdoor.myshopify.com',
    'country-view.myshopify.com',
    'play-brave.myshopify.com',
    'xari-swimwear.myshopify.com',
    'intermodamx.myshopify.com',
    'amoffroad.myshopify.com',
    'vulkan.myshopify.com',
    'sportshopamburgstall.myshopify.com',
    'shay-shoes-store.myshopify.com',
    'kinga4kicks.myshopify.com',
    'mudpuppy-kids.myshopify.com',
    'jettyhome.myshopify.com',
    'neegousa.myshopify.com',
    'prana-chai.myshopify.com',
    'mementosj.myshopify.com',
    'spreezer.myshopify.com',
    'le-pawtique-2.myshopify.com',
    'zoominjewels.myshopify.com',
    'freerangeeq.myshopify.com',
    'p209.myshopify.com',
    'clickshoes-finland.myshopify.com',
    'unicorn-lashes.myshopify.com',
    'densandkennels.myshopify.com',
    'oneill-au.myshopify.com',
    'tusktools-au.myshopify.com',
    'bc-dev-v2-ssr-jena.myshopify.com',
    'boost-pfs-test-v3-jena.myshopify.com',
    'boost-sd-dev-test-jena.myshopify.com',
    'bc-dev-v2-irene02.myshopify.com',
]

export const WHITELIST_TURBO_BANNER_STAGING = [
    'bc-dev-v2-jena12.myshopify.com',
    'bc-dev-v2-jena06.myshopify.com',
    'bc-dev-v2-jena11.myshopify.com',
    'bc-dev-v2-jena12.myshopify.com',
    'bc-dev-v2-jena24.myshopify.com',
    'bc-dev-v2-sunny05.myshopify.com',
    'bc-dev-v2-brian03.myshopify.com',
    'bc-dev-v2-brian04.myshopify.com',
    'bc-dev-v2-brian05.myshopify.com',
    'bc-dev-v2-iris13.myshopify.com',
    'bc-dev-v2-iris10.myshopify.com',
    'bc-dev-v2-sunny10.myshopify.com',
    'bc-dev-v2-sunny12.myshopify.com',
    'bc-dev-v2-sunny14.myshopify.com',
]
